import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import Button from "../../ui/button/button";
import Icon from "../../ui/icon/icon";
import './emptyState.css';

const EmptyState = ({
    children,
    icon,
    title,
    subtitle,
    labelButton,
    to,
    onClick,
    className
}) => {
    return (
        <div className={`wz-empty-state${className ? ` ${className}` : ""}`}>
            {icon && (
                <div className="wz-empty-state__icon">
                    {typeof icon == 'string' ? <Icon size="large" name={icon} /> : {icon}}
                </div>
            )}
            {title && <div className="wz-empty-state__title">{title}</div>}
            {subtitle && (
                <div className="wz-empty-state__subtitle">{subtitle}</div>
            )}
            {labelButton && to && (
                <Button
                    as={Link}
                    to={to}
                    primary
                    inverted
                    label={labelButton}
                />
            )}
            {labelButton && onClick && (
                <Button
                    primary
                    inverted
                    label={labelButton}
                    onClick={onClick}
                />
            )}
            {children}
        </div>
    );
};

EmptyState.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    labelButton: PropTypes.node,
    to: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string
};

EmptyState.defaultProps = {
    icon: null,
    title: null,
    subtitle: null,
    labelButton: null,
    to: "",
    onClick: null,
    children: null,
    className: null
};

export default EmptyState;
